export enum EvidenceType {
  Incidence = 'incidence',
  Picture = 'picture',
  LoadPicture = 'loadPicture',
  Signature = 'pod'
}
